<template>
  <div>
    <MobialisHorizontalRuleHeader class="mb-3">
      <template v-if="!isGmbReviews">{{ $t('message.reviews.reviewsWrapperHeader') }}</template>
      <template v-else><img alt="Google" src="@/assets/google-logo.svg" /></template>
    </MobialisHorizontalRuleHeader>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReviewWrapper',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('reviews', ['isGmbReviews']),
  },
  mounted() {
    // A hacky way to fix the weird IOS blank page issue
    // when a user comes from DHS, credit flow is blank (but DOM is existing!)
    // Force to re-render the app
    // Only for Mobile
    if (this.isAVRMobile) {
      document.body.style.height = 'initial';
      this.$nextTick(() =>
        setTimeout(() => {
          document.body.style.height = '';
        }, 10)
      );
    }
  },
};
</script>

<style lang="scss" scoped></style>
